import { getAuthAxiosBackend } from "@/helpers/axios"

class DistrictsServices {
    get(id) {
        return getAuthAxiosBackend().get('Districts/getDistrictsById/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('Districts/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('Districts/addDistrict', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('Districts/updateDistrict/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('Districts/restoreDistrict/' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('Districts/softDeleteDistrict/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('Districts/deleteDistrict/' + id.toString())
    }
}

export default new DistrictsServices()